let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iTZAy")).then(() => parcelRequire('6eLz4'));